import Section from "../Section";
import type { ReactNode } from "react";
import { H1 } from "../Headers/Headings";
import HamburgerMenu from "../HamburgerMenu/HamburgerMenu";
import { useTranslations } from "../../contexts/Translation";
import { PopupMenu } from "./PopupMenu";
import { MobileNav } from "./MobileNav";
import { FeedbachCard, Improvement, OrgDash, Survey } from "../Icons";
import { useOrganizations } from "../../contexts/UserProvider";
import { FeedbackJourneyLogo } from "../Icons/Logo";
import Link from "../Link/Link";
import styles from "./MainHeader.module.css";

type NavItemProps = {
  href: string;
  text: string;
  icon: ReactNode;
};

const NavItem = ({ href, text, icon }: NavItemProps) => (
  <Link className={styles.navItem} href={href}>
    <span className={styles.navIcon}>{icon}</span>
    {text}
  </Link>
);

const MainHeader = () => {
  const t = useTranslations("menu");
  const { currentRole } = useOrganizations();
  const showShared = ["owner", "member", "supporter"].includes(currentRole);
  const myJourneyItems = (
    <>
      <NavItem href='/surveys' text={t("surveys")} icon={<Survey />} />
      <NavItem href='/improvements' text={t("goals")} icon={<Improvement />} />
      <NavItem href='/cards' text={t("card")} icon={<FeedbachCard />} />
    </>
  );
  const sharedJourneyItems = (
    <>
      <NavItem href='/shared' text={t("sharedSurveys")} icon={<Survey />} />
      <NavItem href='/shared-improvements' text={t("sharedGoals")} icon={<Improvement />} />
      <NavItem href='/shared-cards' text={t("sharedCards")} icon={<FeedbachCard />} />
      <NavItem href='/organization' text={t("orgDash")} icon={<OrgDash />} />
    </>
  );
  return (
    <div className={styles.header}>
      <Section className={styles.section}>
        <div className={styles.content}>
          <MobileNav>
            <div className={styles.navHeading}>{t("myFeedbach")}</div>
            {myJourneyItems}
            {showShared && (
              <>
                <div className={styles.navHeading}>{t("sharedFeedbach")}</div>
                {sharedJourneyItems}
              </>
            )}
          </MobileNav>
          <div className={styles.brand}>
            <H1 className={styles.brandHeading}>
              <Link className={styles.logoLink} href='/' aria-label='Feedback Journey'>
                <FeedbackJourneyLogo w={135} />
              </Link>
              <span>Feedback Journey</span>
            </H1>
          </div>
          <div className={styles.navigation}>
            <PopupMenu text={t("myFeedbach")}>{myJourneyItems}</PopupMenu>
            {showShared && <PopupMenu text={t("sharedFeedbach")}>{sharedJourneyItems}</PopupMenu>}
          </div>
          <div className={styles.actions}>
            <HamburgerMenu />
          </div>
        </div>
      </Section>
    </div>
  );
};

export default MainHeader;
